export const JUNGNA_TABLES = {
  banks: "jungna_banks",
  loginData: "jungna_login_data",
  orders: "jungna_orders",
  productImages: "jungna_product_images",
  products: "jungna_products",
  profiles: "jungna_profiles",
  sellers: "jungna_sellers",
  urlMappings: "jungna_url_mappings",
} as const;

export const JUNGNA_STORAGE = {
  productImages: "product-images",
} as const;

export const JUNGNA_RPC = {
  incrementProductViews: "increment_jungna_product_views",
} as const;
